// Chichewa translations
export const ny: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Makasitomala',
  'menu.products': 'Zinthu',
  'menu.users': 'Ogwiritsa ntchito',
  'menu.settings': 'Makonzedwe',
  'menu.logout': 'Tuluka',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Order Yatsopano',
  'order.title': 'Order Yatsopano',
  'order.customer': 'Kasitomala',
  'order.products': 'Zinthu',
  'order.total': 'Zonse',
  'users.title': 'Ogwiritsa ntchito',
  'users.name': 'Dzina',
  'users.email': 'Imelo',
  'common.yes': 'Inde',
  'common.no': 'Ayi',
  'common.cancel': 'Lekani',
  'common.save': 'Sungani',
  'common.search': 'Fufuzani',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Lowani',
  'login.welcome': 'Takulandirani, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Imelo',
  'signup.phone': 'Foni',
  'menu.reportsAndAccounting': 'Malipoti & Akaunti',
  'menu.systemAndCommunication': 'Dongosolo & Kulumikizana',
};